/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Viacheslav Smalenski
 * @author Ilya Baranchikov
 * @version 1.29.1
 * @since 1.19.0
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { tableContext, tableFilterSuggestUrlSelector } from '../selectors';
import { tableApi } from '../store';

interface IUseTableFilterSuggestApi {
    getSuggest: (fieldName: string, value: string) => void;
    isMultiSelectFetching: boolean;
    result: string[];
}

/* Если в meta не пришли facets */
export const useTableFilterSuggestApi = (multiselect = false): IUseTableFilterSuggestApi => {
    /* API */
    const [triggerInputSearch, resultInputSearch] = tableApi.endpoints.suggestTableFilter.useLazyQuery();
    const [triggerMultiSelect, resultMultiSelect] = tableApi.endpoints.suggestTableMultiSelectFilter.useLazyQuery();

    /* Selectors */
    const filterAndSortSuggestUrl = useSelector(tableFilterSuggestUrlSelector);
    const context = useSelector(tableContext);

    const result = useMemo(
        () => (multiselect ? resultMultiSelect : resultInputSearch).data ?? [],
        [resultMultiSelect, resultInputSearch, multiselect],
    );

    return {
        /* Получение списка facets для фильтра */
        getSuggest: (fieldName: string, value: string) => {
            const url = filterAndSortSuggestUrl;
            if (url) {
                multiselect
                    ? triggerMultiSelect({ url, value: value.trim(), fieldName, context })
                    : triggerInputSearch({ url, value: value.trim(), fieldName, context });
            }
        },
        isMultiSelectFetching: resultMultiSelect.isFetching,
        /* facets */
        result,
    };
};
